var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAcSvg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 471.3 500",
    style: {
      enableBackground: "new 0 0 471.3 500"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#093E66;}\n\t.st1{fill:#125A9B;}\n\t.st2{fill:#FFFFFF;fill-opacity:0.4;}\n\t.st3{fill:#3C91EF;}\n\t.st4{fill:#FFFFFF;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "0,266.9 80.7,228.7 80.7,266.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "471.3,266.9 390.5,228.7 390.5,266.9  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M276.4,0.5l163,166v273.9c0,32.1-25.5,58.1-57,58.1H89c-31.5,0-57-26-57-58.1V58.6C32,26.5,57.5,0.5,89,0.5 H276.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M439.4,166.4H336.3c-31.5,0-59.9-28.9-59.9-61V0.5L439.4,166.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M169.7,218.3L169.7,218.3c0,5.7-4.6,10.4-10.4,10.4H98.6c-5.7,0-10.4-4.6-10.4-10.4l0,0 c0-5.7,4.6-10.4,10.4-10.4h60.7C165.1,207.9,169.7,212.6,169.7,218.3z M251.2,176.8L251.2,176.8c0,5.7-4.6,10.4-10.4,10.4H98.6 c-5.7,0-10.4-4.6-10.4-10.4l0,0c0-5.7,4.6-10.4,10.4-10.4h142.2C246.6,166.5,251.2,171.1,251.2,176.8z M251.2,135.3L251.2,135.3 c0,5.7-4.6,10.4-10.4,10.4H98.6c-5.7,0-10.4-4.6-10.4-10.4l0,0c0-5.7,4.6-10.4,10.4-10.4h142.2C246.6,125,251.2,129.6,251.2,135.3z  M251.2,93.8L251.2,93.8c0,5.7-4.6,10.4-10.4,10.4H98.6c-5.7,0-10.4-4.6-10.4-10.4l0,0c0-5.7,4.6-10.4,10.4-10.4h142.2 C246.6,83.4,251.2,88.1,251.2,93.8z"
  }), /*#__PURE__*/React.createElement("rect", {
    y: 266.9,
    className: "st3",
    width: 471.3,
    height: 156.5
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M151.6,390.1c-17.1,0-30.5-8.5-31-24.6h20.6c0.6,6.1,4.4,9.1,9.9,9.1c5.7,0,9.3-2.8,9.3-7.5 c0-14.7-39.8-6.8-39.5-35c0-15.1,12.3-23.4,29-23.4c17.3,0,29,8.6,29.8,23.8h-21c-0.3-5.1-4-8.2-9.2-8.3c-4.6-0.1-8.2,2.3-8.2,7.2 c0,13.8,39.3,7.6,39.3,34.2C180.6,379,170.2,390.1,151.6,390.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M246.6,309.8h20.5l-28.2,79.5h-24.2l-28.2-79.5h20.6l19.7,60L246.6,309.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M349.4,334.9H328c-2.9-5.3-8.4-8.2-15.6-8.2c-12.5,0-20.7,8.8-20.7,22.7c0,14.7,8.4,23.3,22.3,23.3 c9.6,0,16.3-5.1,19.3-14h-24.6v-14.3h42.1v18c-4.1,13.7-17.3,27.4-38.3,27.4c-23.8,0-40.5-16.6-40.5-40.4s16.6-40.5,40.4-40.5 C331.4,308.9,345.2,318.6,349.4,334.9z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAcSvg);
export default __webpack_public_path__ + "static/media/ac_svg.ec7e418925e907007b729f4ede427374.svg";
export { ForwardRef as ReactComponent };